import React , { Component, Fragment } from 'react'
import { Route, Switch } from "react-router-dom"
import { withTranslation } from 'react-i18next';
import BrandsList from './BrandsList/BrandsList';
import BrandFormations from './BrandsContent/BrandFormations';
import BrandArticles from './BrandsContent/BrandArticles';
import BrandProduits from './BrandsContent/BrandProduits';
import BrandVideos from './BrandsContent/BrandVideos';
import YoutubeVideo from './BrandsVideo/YoutubeVideo';
import BrandsCategories from './BrandsCategories/BrandsCategories';
import BrandsSubCategories from './BrandsSubCategories/BrandsSubCategories';
import { SentryRoute } from 'index';
// import BrandArticlesItem from '../../../components/Brands/BrandArticlesItem/BrandArticlesItem';
class BrandsRouter extends Component {

  UNSAFE_componentWillMount() {
    document.body.classList.add('brands');
  }
  componentWillUnmount() {
    document.body.classList.remove('brands');
  }
  render() {
    const { match, location } = this.props

    return (
      <Fragment>
        <Switch location={location}>
          <SentryRoute exact path={`${match.path}`} component={BrandsList} />
          <SentryRoute path={`${match.path}/formations/:brandId`} component={BrandFormations}/>
          <SentryRoute path={`${match.path}/articles/:brandId`} component={BrandArticles}/>
          <SentryRoute path={`${match.path}/produits/:brandId`} component={BrandProduits}/>
          <SentryRoute path={`${match.path}/videos/:brandId/watch=:youtube_id`} component={YoutubeVideo}/>
          <SentryRoute path={`${match.path}/videos/:brandId`} component={BrandVideos}/>
          <SentryRoute path={`${match.path}/categories/:brandId/:categoryId`} component={BrandsSubCategories} />
          <SentryRoute path={`${match.path}/categories/:brandId`} component={BrandsCategories} />
        </Switch>
      </Fragment>
    )
  }
}

export default withTranslation()(BrandsRouter)